import {ResourceParams} from "../resources";

export type BloggerModalResourceType =
  'advertisement-controls' |
  'competitors-advertisements' |
  'service-ratings';

export const bloggerModalResources: {
  [key in BloggerModalResourceType]: ResourceParams
} = {
  'advertisement-controls': {
    key: 'advertisement-controls',
    name: 'История сотрудничества',
    path: 'advertisement-controls',
  },
  'competitors-advertisements': {
    key: 'competitors-advertisements',
    name: 'Реклама конкурентов',
    path: 'competitors-advertisements',
  },
  'service-ratings': {
    key: 'service-ratings',
    name: 'Оценка сервиса',
    path: 'service-ratings',
  },
};
